const s = {
  name: "CurrencyConversion",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,9c0-2.8,2.2-5,5-5s5,2.2,5,5c0,2.8-2.2,5-5,5S9,11.8,9,9z M14,6c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3
			s3-1.3,3-3C17,7.3,15.7,6,14,6z"/>
		<path class="st0" d="M28,0H0v18h28v-8h6v6.6l-2.3-2.3l-1.4,1.4l4.7,4.7l4.7-4.7l-1.4-1.4L36,16.6V8h-8V0z M2,16V2h24v14H2z"/>
		<path class="st0" d="M32.8,36L26,25.1L19.2,36H32.8z M29.2,34h-6.4l3.2-5.1L29.2,34z"/>
		<path class="st0" d="M40,40V22H12v8H6v-6.6l2.3,2.3l1.4-1.4L5,19.6l-4.7,4.7l1.4,1.4L4,23.4V32h8v8H40z M14,38V24h24v14H14z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyConversion
};
